const galleryImages = [
  {
    src: "/images/1.jpg",
    alt: "Students walking across campus",
  },
  {
    src: "/images/7.jpg",
    alt: "Students playing sports",
  },
  {
    src: "/images/2.jpg",
    alt: "Students enjoying campus life",
  },
  {
    src: "/images/6.jpg",
    alt: "Students enjoying campus life",
  },
  {
    src: "/images/3.jpg",
    alt: "Students playing sports",
  },
  {
    src: "/images/8.webp",
    alt: "Student on campus",
  },
  {
    src: "/images/4.jpg",
    alt: "Student on campus",
  },
    {
    src: "/images/5.jpg",
    alt: "Students walking across campus",
  },
];

const CampusGallery = () => {
  return (
   <section className="w-full bg-white px-4 ">
  <div className="grid gap-2 grid-cols-2 md:grid-cols-4">
    {galleryImages.map((image, index) => (
      <div
        key={index}
        className="
          group
          relative
          h-[280px]
          overflow-hidden
          sm:h-[320px]
          lg:h-[420px]
        "
      >
        <img
          src={image.src}
          alt={image.alt}
          className="
            h-full
            w-full
            object-cover
            transition-transform
            duration-700
            ease-[cubic-bezier(0.22,1,0.36,1)]
            will-change-transform
            group-hover:scale-[1.12]
            group-hover:rotate-[2deg]
          "
        />

        {/* Subtle brand overlay */}
        <div
          className="
            pointer-events-none
            absolute
            inset-0
            bg-[#12539F]/0
            transition-colors
            duration-500
            group-hover:bg-[#12539F]/10
          "
        />
      </div>
    ))}
  </div>
</section>
  );
};

export default CampusGallery;